var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureFireplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52312 20.0904H1.99951C1.44723 20.0904 0.999512 20.5381 0.999512 21.0904V21.9996C0.999512 22.5519 1.44723 22.9996 1.99951 22.9996H21.9995C22.5518 22.9996 22.9995 22.5519 22.9995 21.9996V21.0904C22.9995 20.5381 22.5518 20.0904 21.9995 20.0904H21.5174M2.52312 20.0904V5.99957C2.52312 5.44729 2.97083 4.99957 3.52312 4.99957H6.07819H10.0396H14.0009H17.8607H20.5174C21.0697 4.99957 21.5174 5.44729 21.5174 5.99957V20.0904M2.52312 20.0904H5.49951M21.5174 20.0904H18.4995M18.4995 20.0904V8.86764C18.4995 8.31535 18.0518 7.86764 17.4995 7.86764H6.49951C5.94723 7.86764 5.49951 8.31535 5.49951 8.86764V20.0904M18.4995 20.0904H5.49951",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 19.9996V18.9996C7.99951 18.4473 8.44723 17.9996 8.99951 17.9996H9.83084H13.3007H14.9995C15.5518 17.9996 15.9995 18.4473 15.9995 18.9996V19.9996",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 17.9996C9.89866 17.9996 8.37758 16.665 8.05933 15.0641C8.00034 14.7674 8.33741 14.6128 8.56612 14.8108V14.8108C8.811 15.0228 9.23294 14.8302 9.29349 14.512C9.50154 13.4186 10.1977 11.9819 11.6228 10.7632C12.1203 10.3377 12.8576 10.6097 13.0531 11.2345L13.3355 12.1371C13.4431 12.481 13.8358 12.6437 14.1551 12.4767V12.4767C14.54 12.2754 14.9693 12.5534 14.9385 12.9866C14.8978 13.5596 14.8868 14.1752 15.1049 14.5373C15.1716 14.6482 15.3027 14.6932 15.4321 14.6932V14.6932C15.7371 14.6932 15.9756 14.9548 15.9155 15.2538C15.7091 16.2795 15.0954 17.9996 13.4984 17.9996",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureFireplace);
export default __webpack_public_path__ + "static/media/feature_fireplace.477ace7b97aeac00b2eec208816eae0d.svg";
export { ForwardRef as ReactComponent };